module.exports = __webpack_public_path__ + "img/cbam-2.9f0c649e.png";